export var CLH_SESSION_ID = crypto.randomUUID();
